import i18n from "i18next";
import { ColumnsType } from "antd/lib/table/interface";
import EditIcon from "@static/core/icons/icon-edit.svg?react";
import DeleteIcon from "@static/core/icons/icon-delete.svg?react";
import JseCertificateIcon from "@static/core/icons/icon-jse-certificate.svg?react";
import USInvalidCertificateIcon from "@static/core/icons/icon-us-invalid-certificate.svg?react";
import USProgressCertificateIcon from "@static/core/icons/icon-us-progress-certificate.svg?react";
import JseMemberIcon from "@static/core/icons/icon-jse-member.svg?react";
import { Guest, GuestProfile } from "@type/core/offices/offices.types";
import InfoModal from "@components/core/modals/InfoModal";
import React from "react";
import GuestSignaturePicture from "@components/core/signature/GuestSignaturePicture";
import { Select } from "antd";
const { Option } = Select;

const signatureProfiles: GuestProfile[] = [
  "Signer électroniquement",
  "Signer et sceller électroniquement",
];

export const columns = (
  setIsDeleteGuestOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsUpdateGuestOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setIsSignaturePicturePriorityOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >,
  setSelectedGuest: React.Dispatch<React.SetStateAction<Guest | undefined>>,
  setPendingSignaturePriorityChange: React.Dispatch<
    React.SetStateAction<{ newPriority: string; guestId?: string }>
  >,
): ColumnsType<Guest> => [
  {
    title: i18n.t("offices.users.guests.headers.email"),
    dataIndex: "email",
    sorter: true,
    showSorterTooltip: false,
  },
  {
    title: i18n.t("offices.users.guests.headers.profile"),
    dataIndex: "profile",
    sorter: true,
    showSorterTooltip: false,
  },
  {
    title: i18n.t("offices.users.guests.headers.active"),
    dataIndex: "active",
    sorter: true,
    showSorterTooltip: false,
    render: (active: boolean) => {
      return active ? "Oui" : "Non";
    },
  },
  {
    title: (
      <>
        {i18n.t("offices.users.guests.headers.guestSignaturePicture")}
        <InfoModal value="guestSignaturePicture" info />
      </>
    ),
    dataIndex: "guestSignaturePicture",
    render: (_, guest: Guest) => {
      return (
        signatureProfiles.includes(guest.profile) && (
          <GuestSignaturePicture guest={guest} />
        )
      );
    },
  },
  {
    title: (
      <>
        {i18n.t("offices.users.guests.headers.signaturePriority")}
        <InfoModal value="signaturePriority" info />
      </>
    ),
    dataIndex: "signaturePriority",
    render: (_, guest: Guest) => {
      const options: { label: string; value: string }[] = [
        { value: "DEFAULT_SIGNATURE_PICTURE", label: "Par défaut" },
      ];

      if (guest.guestSignaturePicture) {
        options.unshift({
          value: "GUEST_SIGNATURE_PICTURE",
          label: "Image de signature",
        });
      }
      return (
        <Select
          className="w-200px"
          value={guest.signaturePriority || "Par défaut"}
          onChange={(value) => {
            setPendingSignaturePriorityChange({
              newPriority: value,
              guestId: guest.id,
            });
            setSelectedGuest(guest);
            setIsSignaturePicturePriorityOpen(true);
          }}
        >
          {options.map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select>
      );
    },
  },
  {
    title: i18n.t("offices.users.guests.headers.csoStatus"),
    dataIndex: "status",
    width: 76,
    render: (status: string) => {
      return (
        <>
          {status && status === "VALID" && (
            <div className="d-flex justify-content-center">
              <JseCertificateIcon className="picto icon-30" />
            </div>
          )}
          {status && status === "INVALID" && (
            <div className="d-flex justify-content-center">
              <USInvalidCertificateIcon className="picto icon-30" />
            </div>
          )}
          {status && (status === "PROGRESS" || status === "STARTED") && (
            <div className="d-flex justify-content-center">
              <USProgressCertificateIcon className="picto icon-30" />
            </div>
          )}
          {(!status || status === "" || status === "NOT_STARTED") && (
            <div className="d-flex justify-content-center">
              <JseMemberIcon className="picto icon-30" />
            </div>
          )}
        </>
      );
    },
  },
  {
    dataIndex: "id",
    width: 108,
    render: (_, guest: Guest) => {
      return (
        <div className="d-flex align-items-center justify-content-center gap-24">
          <EditIcon
            className="picto icon-30"
            onClick={() => {
              setSelectedGuest(guest);
              setIsUpdateGuestOpen(true);
            }}
          />
          <DeleteIcon
            className="picto icon-30"
            onClick={() => {
              setSelectedGuest(guest);
              setIsDeleteGuestOpen(true);
            }}
          />
        </div>
      );
    },
  },
];
